import lafan1Samples from '$lib/data/lafan1.json';

export const poseDataSource = 'lafan1';

type PoseSampleSourceEntry = {
	key: string;
	title: string;
	category: string;
	primary?: boolean;
};

export type MotionSample = {
	key: string;
	title: string;
};

const humanizeCategory = (category: string) =>
	category.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (char) => char.toUpperCase());

const orderedCategories: string[] = [];
const primaryByCategory = new Map<string, PoseSampleSourceEntry>();

for (const sample of lafan1Samples as PoseSampleSourceEntry[]) {
	if (!orderedCategories.includes(sample.category)) {
		orderedCategories.push(sample.category);
	}
	if (sample.primary) {
		primaryByCategory.set(sample.category, sample);
	}
}

for (const sample of lafan1Samples as PoseSampleSourceEntry[]) {
	if (!primaryByCategory.has(sample.category)) {
		primaryByCategory.set(sample.category, sample);
	}
}

export const motionSamples: MotionSample[] = orderedCategories
	.map((category) => primaryByCategory.get(category))
	.filter((sample): sample is PoseSampleSourceEntry => Boolean(sample))
	.map((sample) => ({
		key: sample.key,
		title: humanizeCategory(sample.category)
	}));
